<script>
import isNotEmpty from '../../utils/object/is-not-empty.js';
import BaseComponent from '../base-component/base-component.vue';


export default {
  name: 'BaseEditable',
  extends: BaseComponent,
  inject: {
    $parentInstance: { default: undefined },
    $uiForm:         { default: undefined },
    $uiFormControl:  { default: undefined },
    $uiFormField:    { default: undefined },
  },
  props: {
    modelValue:    { type: null,    default: undefined },
    defaultValue:  { type: null,    default: undefined },
    name:          { type: null,    default: undefined },
    invalid:       { type: Boolean, default: undefined },
    disabled:      { type: Boolean, default: false, },
    formControl:   { type: Object,  default: undefined },
  },
  emits: ['update:modelValue', 'value-change'],
  data () {
    return {
      d_value: this.defaultValue || this.modelValue,
    };
  },
  computed: {
    $filled () {
      return isNotEmpty(this.d_value);
    },
    $invalid () {
      return !this.$formNovalidate && this.findNonEmpty(this.invalid, this.$uiFormField?.$field?.invalid, this.$uiForm?.getFieldState(this.$formName)?.invalid);
     },
    $formName () {
      return !this.$formNovalidate ? this.name || this.$formControl?.name : undefined;
    },
    $formControl() {
      return this.formControl || this.$uiFormField?.formControl;
    },
    $formNovalidate() {
      return this.$formControl?.novalidate;
    },
    $formDefaultValue() {
      return this.findNonEmpty(this.d_value, this.$uiFormField?.initialValue, this.$uiForm?.initialValues?.[this.$formName]);
    },
    $formValue() {
      return this.findNonEmpty(this.$uiFormField?.$field?.value, this.$uiForm?.getFieldState(this.$formName)?.value);
    },
    controlled() {
      /* eslint-disable no-prototype-builtins */
      return this.$inProps.hasOwnProperty('modelValue')
        || (!this.$inProps.hasOwnProperty('modelValue')
        && !this.$inProps.hasOwnProperty('defaultValue'));
    },
  },
  watch: {
    modelValue (newValue) {
      this.d_value = newValue;
    },
    defaultValue (newValue) {
      this.d_value = newValue;
    },
    ///////////////////////////
    ///  Not using forms yet. And there is for sure a bug in the $formDefaultValue
    ///  handler. When not using the control in a form, this obliterates the
    ///  initial value for d_value.
    // $formName: {
    //   immediate: true,
    //   handler (newValue) {
    //     this.formField = this.$uiForm?.register?.(newValue, this.$formControl) || {};
    //   }
    // },
    // $formControl: {
    //   immediate: true,
    //   handler(newValue) {
    //     this.formField = this.$uiForm?.register?.(this.$formName, newValue) || {};
    //   }
    // },
    // $formDefaultValue: {
    //   immediate: true,
    //   handler (newValue) {
           // PROBABLY SHOULD BE PROCTECTED HERE, THIS OBLITERATES THE INITIAL
           // VALUE ON STARTUP.
    //     this.d_value !== newValue && (this.d_value = newValue);
    //   }
    // },
    // $formValue: {
    //   immediate: false,
    //   handler (newValue) {
    //     if (this.$uiForm?.getFieldState(this.$formName) && newValue !== this.d_value) {
    //       this.d_value = newValue;
    //     }
    //   }
    // },
    // /////////////////////////
  },
  methods: {
    writeValue (value, event) {
      if (this.controlled) {
        this.d_value = value;
        this.$emit('update:modelValue', value);
      }
      this.$emit('value-change', value);
      this.formField?.onChange?.({originalEvent:event, value});
    },
    // TODO: Move to utils?
    findNonEmpty (...values) {
      return values.find(isNotEmpty);
    }
  },
};
</script>
